import { LocationValue } from '@/widgets/LocationPicker/models';

import { geoUrls } from '@/api/urls/geo';

import { setApiOptions } from '@/utilities/services';

import { RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import { CityItem, GetCitiesQueryParam, GetNearestCityResponseType } from '@/client/services/geo/cities/models';
import { AxiosPromise } from 'axios';

export const getCitiesService = (queryParam?: GetCitiesQueryParam): AxiosPromise<RequestResponseType<CityItem[]>> => {
    const options = setApiOptions(geoUrls.getCities, { queryParam });
    return api({ ...options, method: 'GET' });
};

export const getNearestCityByLocationService = (bodyParam: LocationValue): AxiosPromise<RequestResponseType<GetNearestCityResponseType>> => {
    const options = setApiOptions(geoUrls.getNearestCity, { bodyParam });
    return api({ ...options, method: 'POST' });
};
